import React from "react";

function DiscoverIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <g
        id="Group_24036"
        data-name="Group 24036"
        transform="translate(-6623 -2045)"
      >
        <rect
          id="Rectangle_12669"
          data-name="Rectangle 12669"
          width="32"
          height="32"
          transform="translate(6623 2045)"
          fill="var(--primary-black)"
          opacity="0"
        />
        <path
          id="Path_16175"
          data-name="Path 16175"
          d="M20.94,19.269,26,24.329,24.329,26l-5.06-5.06a10.636,10.636,0,1,1,1.671-1.671Zm-2.37-.877a8.268,8.268,0,1,0-.177.177Z"
          transform="translate(6625 2047)"
          fill="var(--primary-black)"
        />
      </g>
    </svg>
  );
}

export default DiscoverIcon;
